const types = {
  TOGGLE_SNACKBAR: 'TOGGLE_SNACKBAR',
  SET_BUILD_LOADER: 'SET_BUILD_LOADER',
  SET_DEPLOY_LOADER: 'SET_DEPLOY_LOADER',
  SELECTED_NODE: 'SELECTED_NODE',
  SET_SELECTED_TRANSACTION_ID: 'SET_SELECTED_TRANSACTION_ID',
  SET_SELECTED_EVENT: 'SET_SELECTED_EVENT',
  SET_DF_RENDER: 'SET_DF_RENDER',
  SET_TV_RENDER: 'SET_TV_RENDER',
  TRANSCTION_RENDER_COUNT: 'TRANSCTION_RENDER_COUNT',
  UPDATE_BLUEPRINT_SLUG_DETAILS: 'UPDATE_BLUEPRINT_SLUG_DETAILS',
  UPDATE_FULL_GLOBAL: 'UPDATE_FULL_GLOBAL',
  OPEN_LEFT_DRAWER: 'OPEN_LEFT_DRAWER',
  CLOSE_LEFT_DRAWER: 'CLOSE_LEFT_DRAWER',
  TOGGLE_LEFT_DRAWER: 'TOGGLE_LEFT_DRAWER',
  TOGGLE_RIGHT_DRAWER: 'TOGGLE_RIGHT_DRAWER',
  TOGGLE_BOTTOM_DRAWER: 'TOGGLE_BOTTOM_DRAWER',
  SET_FOCUS_ELEMENT: 'SET_FOCUS_ELEMENT',
  SET_ACTIVE_LABEL: 'SET_ACTIVE_LABEL',
  HANDLE_LOGS: "HANDLE_LOGS",
  HANDLE_BOTTOM_TERMIAL: "HANDLE_BOTTOM_TERMIAL",
  HANDLE_TOP_RIGHT_INFO: "HANDLE_TOP_RIGHT_INFO",
  SET_TAB_ON_FOCUS: 'SET_TAB_ON_FOCUS',
  SET_ELEMENT_TO_COPY: 'SET_ELEMENT_TO_COPY',
  SET_TESTCASE_TO_COPY: 'SET_TESTCASE_TO_COPY',
  DRAW_EVENT: 'DRAW_EVENT',
  DRAW_NESTED_TRANSACTION: 'DRAW_NESTED_TRANSACTION',
  DRAW_REUSE_TRANSACTION: 'DRAW_REUSE_TRANSACTION',
  TRANSACTION_TO_CREATE: 'TRANSACTION_TO_CREATE',
  SET_TRANSACTION_STATE: 'SET_TRANSACTION_STATE',
  SET_TERMINAL_OPEN: 'SET_TERMINAL_OPEN',
  HIGHLIGHT_NODE: 'HIGHLIGHT_NODE',
  DRAWN_TRANSACTION: 'DRAWN_TRANSACTION',
  SAVING_IN_PROGRESS: 'SAVING_IN_PROGRESS',
  SET_CLICKED_NODE: 'SET_CLICKED_NODE',
  SET_DISABLE_PAN: 'SET_DISABLE_PAN',
  SET_LATEST_FIELD_ADDED: 'SET_LATEST_FIELD_ADDED',
  SET_LOADING_FALSE: "SET_LOADING_FALSE",
  DRAW_TEMPLATE_TRANSACTION: 'DRAW_TEMPLATE_TRANSACTION',
  SET_CURRENT_TEMPLATE_TRANSACTION: 'SET_CURRENT_TEMPLATE_TRANSACTION',
  SET_APP_MODE: 'SET_APP_MODE',
  CURRENT_VIEW_ID: 'CURRENT_VIEW_ID',
  TOGGLE_SEC_SNACKBAR: 'TOGGLE_SEC_SNACKBAR',
  SET_MENU_ACTION: 'SET_MENU_ACTION',
  SET_VIEW_ELEMENT_TO_COPY: 'SET_VIEW_ELEMENT_TO_COPY',
  SET_API_RESPONSE_CODE: 'SET_API_RESPONSE_CODE',
  SET_RE_RENDER: 'SET_RE_RENDER',
  SET_TRIGGER_VALIDATION: 'SET_TRIGGER_VALIDATION',
  DETECT_PLATFORM_SCHEMA_CHANGE: 'DETECT_PLATFORM_SCHEMA_CHANGE',
  SET_INNER_SCREEN_RENDER: 'SET_INNER_SCREEN_RENDER',
  SET_API_RESPONSE_MESSAGE: 'SET_API_RESPONSE_MESSAGE',
  SET_HEADER_NAME: 'SET_HEADER_NAME',
  SET_TRANSACTION_EVENTS: 'SET_TRANSACTION_EVENTS',
  SET_TRANSACTION_CLUSTERLETS: 'SET_TRANSACTION_CLUSTERLETS',
  SET_TRANSACTION_CHILDREN: 'SET_TRANSACTION_CHILDREN',
  SET_PARENT_TRANSACTION: 'SET_PARENT_TRANSACTION',
  SET_DISABLED: 'SET_DISABLED',
  SET_CODE_EDIT_STATUS: 'SET_CODE_EDIT_STATUS',
  SET_IS_DOCUMENT_CLICKED: 'SET_IS_DOCUMENT_CLICKED',
  SET_SIMULATION_TRANSACTION: 'SET_SIMULATION_TRANSACTION',
  SET_IMAGE_MAP: 'SET_IMAGE_MAP',
  RESET_IMAGE_MAP: 'RESET_IMAGE_MAP',
  TOGGLE_MULTI_LINE_SNACKBAR: 'TOGGLE_MULTI_LINE_SNACKBAR',
  SET_BOTTOM_TERMINAL_CLOSED: 'SET_BOTTOM_TERMINAL_CLOSED',
  OPEN_TRANSACTION_SELECTOR: 'OPEN_TRANSACTION_SELECTOR',
  SET_PAPER_FOR_SIMULATION_TRANSACTION: 'SET_PAPER_FOR_SIMULATION_TRANSACTION',
  SET_NODE_EXPANDED: 'SET_NODE_EXPANDED',
  SET_BUILD_STATUS: 'SET_BUILD_STATUS',
  TRIGGER_TOUR: 'TRIGGER_TOUR',
  TOGGLE_NEXT_STEP: 'TOGGLE_NEXT_STEP',
  OPEN_RIGHT_DRAWER: 'OPEN_RIGHT_DRAWER',
  INIT_MIGRATION_APPROVAL: 'INIT_MIGRATION_APPROVAL',
  SAVE_DIALOG_SCROLL_LOCATION: 'SAVE_DIALOG_SCROLL_LOCATION',
  SET_TRANSACTION_INVOKED: 'SET_TRANSACTION_INVOKED',
  SET_DASHBOARD_REFRESH: 'SET_DASHBOARD_REFRESH',
  START_UPLOAD_PROGRESS: 'START_UPLOAD_PROGRESS',
  UPDATE_UPLOAD_PROGRESS: 'UPDATE_UPLOAD_PROGRESS',
  REMOVE_UPLOAD_PROGRESS: 'REMOVE_UPLOAD_PROGRESS',
  ADD_TOUR_CONFIG: 'ADD_TOUR_CONFIG',
  GENERATE_LLM_COMPONENTS : 'GENERATE_LLM_COMPONENTS',
  SHOW_ACCEPT_REJECT_BUTTONS:'SHOW_ACCEPT_REJECT_BUTTONS',
  SET_BUILD_VERSION: 'SET_BUILD_VERSION',
  LLM_QUERY : "LLM_QUERY",
  LLM_MODEL : "LLM_MODEL",
  SET_FORCED_FOCUS: 'SET_FORCED_FOCUS',
  AI_ASSISTANT_UPDATE: 'AI_ASSISTANT_UPDATE',
  AI_ASSISTANT_MODAL_OPEN: 'AI_ASSISTANT_MODAL_OPEN',
  AI_ASSISTANT_MODAL_CLOSE: 'AI_ASSISTANT_MODAL_CLOSE',
  COLLAPSABLE_SIDEBAR_STATUS : "COLLAPSABLE_SIDEBAR_STATUS",
  SET_AI_REQUEST_ENTITY:"SET_AI_REQUEST_ENTITY",
  GENERATE_WIDGET_TRANSACTION: 'GENERATE_WIDGET_TRANSACTION',
  SET_AI_AUTO_PROCEED: 'SET_AI_AUTO_PROCEED',
  SET_LOG_HELPER: 'SET_LOG_HELPER',
  TOGGLE_SIMULATION_RUN: 'TOGGLE_SIMULATION_RUN',
  TOGGLE_VALIDATOR: "TOGGLE_VALIDATOR",
  TOGGLE_DEPLOYMENT: "TOGGLE_DEPLOYMENT",
  UPDATE_LOG_REDIRECTION_DATA: "UPDATE_LOG_REDIRECTION_DATA"
};

export default types;